import { PublicCookie } from "../models/public-cookie.model";
import { CookieHelper } from "./cookie.helper";

export class PublicCookieHelper {
    private static readonly cookieName = "Auth.PublicCookies";

    public static get(): PublicCookie | null {
        const cookie = CookieHelper.getCookie(PublicCookieHelper.cookieName);
        if (!cookie) {
            return null;
        }

        return JSON.parse(cookie, (key, value) => {
            if (key === "tokenExpiration") {
                return new Date(value);
            }
            return value;
        }) as PublicCookie
    }

    public static create(publicCookie: PublicCookie) {
        CookieHelper.setCookie(PublicCookieHelper.cookieName, encodeURIComponent(JSON.stringify(publicCookie)));
    }

    public static isValid(publicCookie: PublicCookie | null): publicCookie is PublicCookie {
        return !!publicCookie && publicCookie.isAuthenticated;
    }

    public static getExpirationMinusSafetyTime(publicCookie: PublicCookie, safetyTimeInSeconds: number): number {
        return publicCookie.tokenExpiration.getTime() - (safetyTimeInSeconds * 1000);
    }

    public static deletePublicCookie() {
        CookieHelper.eraseCookie(PublicCookieHelper.cookieName);
    }
}